"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const mask_1 = __importDefault(require("../mask"));
const item_1 = __importDefault(require("./item"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('filter');
const InternalFilter = (props) => {
    const filterRef = react_1.useRef([]);
    const { style, zIndex, children } = props;
    const [showMask, setShowMask] = react_1.useState(false);
    const hanldeShowMask = (value) => {
        setShowMask(value);
    };
    const handleTapItem = (value, index, tapCb) => {
        filterRef.current.forEach((item, cindex) => {
            if (index !== cindex) {
                item.current.close();
            }
        });
        if (value) {
            setShowMask(true);
        }
        else {
            setShowMask(false);
        }
        tapCb === null || tapCb === void 0 ? void 0 : tapCb();
    };
    const hanldeTapMask = () => {
        filterRef.current.forEach(item => {
            item.current.close();
        });
        setShowMask(false);
    };
    const filterItems = react_1.default.Children.map(children, (filterItem, index) => {
        const itemRef = react_1.useRef();
        filterRef.current[index] = itemRef;
        if (filterItem.ref) {
            filterRef.current[index] = filterItem.ref;
        }
        return (react_1.default.createElement(item_1.default, Object.assign({}, filterItem.props, { ref: filterRef.current[index], onTap: v => { var _a; return handleTapItem(v, index, (_a = filterItem.props) === null || _a === void 0 ? void 0 : _a.onTap); }, onShowMask: hanldeShowMask, id: index })));
    });
    const isAddZIndex = zIndex || zIndex === 0;
    let filterStyle = style;
    if (isAddZIndex) {
        filterStyle = Object.assign(Object.assign({}, style), { zIndex });
    }
    return (react_1.default.createElement(one_1.View, { className: prefixCls, style: filterStyle },
        react_1.default.createElement(one_1.View, { className: `${prefixCls}-content`, style: { height: showMask ? '100%' : '100px' } },
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-items` }, filterItems)),
        react_1.default.createElement(mask_1.default, { show: showMask, onTap: hanldeTapMask, style: {
                top: 'unset',
                bottom: 'unset',
                height: '100%',
            }, zIndex: 0 })));
};
exports.default = InternalFilter;
// {/* mask必须放到items的后面,否则会导致动画transition失效 */}
